module.exports = require("./cs.d.ts");